export default __webpack_public_path__ + "static/media/logo.6f019da4.png";